const handleItemCheckboxChange = props => {
  const {
    event,
    setErrorSteps,
    removeReturnItem,
    setOrderItems,
    orderItems,
    parts,
  } = { ...props }

  const {
    name: targetName,
    checked: isChecked,
    value: qtyToReturn = 0,
  } = event.target
  const orderItemIdNo = targetName.replace('RMA', '')
  if (isChecked) {
    setErrorSteps({
      errorReturnPart: '',
    })
    /* adding parts selection to the context  */
    setOrderItems([...orderItems, {
      ...parts,
      displayChatBox: false,
      returnQty: parseInt(qtyToReturn, 10) || 1,
      images: [],
      reasons: [],
      comment: '',
      documents: [],
    }])
  } else {
    /* if unchecked it will removed the information to the context */
    removeReturnItem(orderItemIdNo)
  }
}

export default handleItemCheckboxChange
